import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { WorkflowOrigin } from '@warema/shared/models';
import { first, map, switchMap } from 'rxjs/operators';
import { UserCentricsService } from './user-centrics.service';

export const consentGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const userCentricsService = inject(UserCentricsService);

    // TODO: subscribe to consent revoked event of services and redirect if still on this route

    const consentName = route.data['consent'] as string;

    return userCentricsService.isLoaded.pipe(
        first(isLoaded => isLoaded),
        switchMap(() => userCentricsService.hasUserCurrentlyConsented(consentName)),
        // eslint-disable-next-line sonarjs/function-return-type
        map((consented): GuardResult => {
            if (!consented) {
                userCentricsService.redirectUrl = state.url;
                // Keep Origin when redirecting (i.e. to disable Header in SunCenter)
                const origin = route.queryParams['origin'] as WorkflowOrigin;

                return router.createUrlTree(['consent'], { queryParams: { consentName, origin } });
            }

            return true;
        }),
    );
};
